function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:1.5px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.77 0.799)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M30.8,28.8l-3.272,4.087a34.533,34.533,0,0,1-12.27-12.266l4.09-3.272a2.78,2.78,0,0,0,.8-3.3l-3.728-8.4A2.78,2.78,0,0,0,13.187,4.09l-7.1,1.841A2.8,2.8,0,0,0,4.027,9.019a41.24,41.24,0,0,0,35.1,35.1,2.8,2.8,0,0,0,3.088-2.063l1.841-7.1A2.782,2.782,0,0,0,42.5,31.722L34.1,27.993a2.777,2.777,0,0,0-3.3.8Z",
  transform: "translate(-4 -4)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M35,5A17.207,17.207,0,0,1,52.207,22.207",
  transform: "translate(-12.775 -4.283)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M43.6,25.6A8.6,8.6,0,0,0,35,17",
  transform: "translate(-12.775 -7.679)"
}));

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.717,
    height: 41.718,
    viewBox: "0 0 41.717 41.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.c372dca0.svg";
export { ForwardRef as ReactComponent };